// Bewerberprofil ("Erzähl uns von dir"). Die Slugs validiert das Backend
// (backend/config/constants.js), die deutschen Labels stehen nur hier.

export const SCHOOL_STATUS_LABELS = {
  schueler: 'Noch Schüler/in',
  hauptschulabschluss: 'Hauptschulabschluss / Berufsreife',
  mittlere_reife: 'Mittlere Reife / Sekundarabschluss I',
  fachabitur: 'Fachabitur',
  abitur: 'Abitur',
};

export const TRAINING_STATUS_LABELS = {
  keins: 'Keine Ausbildung, kein Studium',
  ausbildung_laufend: 'Ausbildung läuft',
  ausbildung_abgebrochen: 'Ausbildung abgebrochen',
  studium_laufend: 'Studium läuft',
  studium_abgebrochen: 'Studium abgebrochen',
};

export const EXPERIENCE_TYPE_LABELS = {
  nebenjob: 'Nebenjob',
  praktikum: 'Praktikum',
  ehrenamt: 'Ehrenamt',
};

export const LANGUAGE_LEVEL_LABELS = {
  grundkenntnisse: 'Grundkenntnisse',
  gut: 'Gut',
  fliessend: 'Fließend',
  muttersprache: 'Muttersprache',
};

export const DRIVERS_LICENSE_LABELS = {
  keiner: 'Keiner',
  am: 'AM (Roller)',
  b17: 'B17 (begleitet)',
  b: 'B (Auto)',
};

export const LANGUAGE_SUGGESTIONS = [
  'Deutsch', 'Englisch', 'Französisch', 'Türkisch', 'Arabisch', 'Russisch',
  'Polnisch', 'Italienisch', 'Spanisch', 'Ukrainisch', 'Rumänisch', 'Kurdisch',
];

// Gespeichert werden die Labels selbst (youth_profiles.skills ist TEXT[]),
// eigene Skills landen in derselben Liste.
export const SKILL_GROUPS = [
  { title: 'Kundenkontakt & Kasse', skills: ['Kasse', 'Kundenberatung', 'Verkauf', 'Telefon & Empfang'] },
  { title: 'Gastro & Küche', skills: ['Service & Bedienung', 'Küchenhilfe', 'Barista', 'Theke & Imbiss'] },
  { title: 'Handwerk & Technik', skills: ['Handwerkliches Geschick', 'Werkzeug & Maschinen', 'Fahrrad- & Rollerreparatur', 'Gartenarbeit'] },
  { title: 'Lager & Logistik', skills: ['Kommissionieren', 'Regale einräumen', 'Pakete & Versand', 'Inventur'] },
  { title: 'Kinderbetreuung', skills: ['Babysitten', 'Nachhilfe', 'Hausaufgabenbetreuung', 'Jugendgruppe leiten'] },
  { title: 'PC & Office', skills: ['Word', 'Excel', 'PowerPoint', '10-Finger-Schreiben'] },
  { title: 'Social Media', skills: ['Instagram', 'TikTok', 'Fotos & Videos bearbeiten', 'Canva'] },
  { title: 'Nachweise & Kurse', skills: ['Erste-Hilfe-Kurs', 'Rettungsschwimmer', 'Hygienebelehrung (Gastro)', 'Juleica'] },
  { title: 'Das zeichnet mich aus', skills: ['Teamfähig', 'Zuverlässig', 'Pünktlich', 'Belastbar', 'Freundlich'] },
];

export const PRESET_SKILLS = SKILL_GROUPS.flatMap(g => g.skills);
